export const loginErrorHandler = (error) => {
	const errorMapping = {
		'wrong-password': 'email atau password salah !',
		'user-not-found': 'email tidak dapat ditemukan',
		'email-not-verified': 'harap lakukan verifikasi email',
		'login-failed': 'terjadi masalah pada saat login, silakah coba lagi',
	};

	const errorMessage = error.split('/')[1];

	if (errorMapping[errorMessage]) {
		return errorMapping[errorMessage];
	}

	return 'periksa kembali email / password anda !';
};

// General Error Handler untuk Firestore
export const firestoreErrorHandler = (error) => {
	const errorCode = error?.code || 'default';

	const firestoreErrorMessages = {
		'permission-denied': "You don't have permission to access the data.",
		unavailable:
			'The service is currently unavailable. Please try again later.',
		'invalid-argument': 'The requested document reference is invalid.',
		'data-not-exist': 'Data that you find is not exist',
		default: 'An unexpected error occurred. Please try again.',
	};

	const errorMessage = firestoreErrorMessages[errorCode];

	// Mengembalikan objek dengan data null dan pesan error
	return { data: null, message: errorMessage, code: errorCode };
};
